import { wavefrontPolynomialFieldSettings, wavefrontPolynomialFieldParameters } from './shared.js';

export default {
  label: 'Wavefront polynomial versus field', group: 'performance',
  description: 'A Zernike coefficient, or the magnitude of a pair of terms, along a field slice. The number of fit terms does not choose the coefficient shown; select it with the coefficient settings.',
  settingsSchema: wavefrontPolynomialFieldSettings,
  parameters: wavefrontPolynomialFieldParameters,
  coverage: 'For focal (non-afocal) systems, along the X or Y axis of the field. Coefficients and magnitudes are in waves at the wavelength CODE V reports, and orientations in degrees. A single term can be negative even where CODE V labels it a magnitude. Not supported: coefficient 0, oblique slices and two-dimensional maps.',
} as const;
